import React, { useRef } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { viewPortHeight_350 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { AllManufacturer } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  NOT_SELECTED_ROW,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  dispatchErrorMsgDisputeRecap,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRecapGrid,
  getDisplayRecapGrid,
  getManufacturerList,
  dispatchDrugSelected,
  dispatchQuarterSelected,
  dispatchRecentlyClosed,
  getManufactureName,
  getManufactureID,
  dispatchIncludeActivity,
  dispatchRebateProgramName,
  getDramsInvStartQtr,
  dispatchDisplayObjRecap,
  dispatchPerformDisputeResolutionObj,
  setLoading,
} from '../Store/action';
import {
  checkQuarterValidation,
  compareQtrs,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const DisputeRecapitulation = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const resultanufacturerList = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.manufacturerList
  );
  const getDisplayRecapGridList = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.recapGrid
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.DisputeRecapReducer?.performDisputeResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.planType
  );

  const getDRAMSListData = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.dramsInvoice
  );

  const dispute_codes = useSelector(
    (state) => state?.sharedState?.DisputeRecapReducer?.dispute_codes
  );
  const {
    errorMsgDisputeRecap: getErrorMsg,
    checkedValue: checkRedValue,
    rebateProgramName: getRebateProgramName,
  } = useSelector((state) => state?.sharedState?.DisputeRecapReducer);
  const dispatch = useDispatch();
  const gridRef = useRef();
  const [gridParams, setGridParams] = React.useState(null);
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [checked, setChecked] = React.useState(checkRedValue);
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [menuName, setMenuName] = React.useState();
  const [dramsData, setDramsData] = React.useState();
  const [manufacturerWithId, setManufactureWithId] = React.useState([]);

  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
        planTypeCd: userDefaults?.planTypeCd
          ? userDefaults?.planTypeCd
          : 'FD',
        rebateProgramCd:
          getRebateProgramName?.rebateProgramCd ||
            userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
            userDefaults?.rebateProgramCd
            : '-1',
        startingQtr: '',
        endingQtr: '',
        qtrSelected: 'All',
        drugSelected: 'Current Disputes',
        checkBoxValue: false,
        currentIndex: 0,
      }
  );
    const [gridApi, setGridApi] = React.useState(null);
  
   React.useEffect(() => {
      if (!gridApi || manufacturerList === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
        onSelectionChanged({ api: gridApi }); 
      }
    }, [gridApi, manufacturerList]);
  // handing by default first row selection function
  const onGridReady = (params) => {
    setGridParams(params);
    setGridApi(params.api);
    // setTimeout(() => {
      if (params && params.api) {
        params.api.forEachNode(
          (node) =>
            node.rowIndex === state.currentIndex && node.setSelected(true)
        );
        onSelectionChanged({ api: params.api, rowIndex: state.currentIndex });
        dispatch(
          dispatchPerformDisputeResolutionObj({
            ...requestCurrentDisData,
            state: { ...state, currentIndex: 0 },
          })
        );
      }
    // }, 2000);
  };
  const onFirstDataRendered = (params) => {
    dispatch(dispatchErrorMsgDisputeRecap([]));
    setGridParams(params);
    if (params && params.api) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex === state.currentIndex && node.setSelected(true)
      );
      onSelectionChanged({ api: params.api, rowIndex: state.currentIndex });
      dispatch(
        dispatchPerformDisputeResolutionObj({
          ...requestCurrentDisData,
          state: { ...state, currentIndex: 0 },
        })
      );
    }
  };
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);
  // FullScreen Functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  
  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgDisputeRecap([]));
  }, [checked, planTypeList, state.planTypeCd, resultanufacturerList, rebateProgramName, getDRAMSListData, dispute_codes]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    dispatch(dispatchErrorMsgDisputeRecap([]));
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      dispatch(
        dispatchPerformDisputeResolutionObj({
          ...requestCurrentDisData,
          state: { ...state, [name]: value, rebateProgramCd: '-1' },
        })
      );
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    } else if (name === 'qtrSelected') {
      setState({ ...state, [name]: value, startingQtr: '', endingQtr: '' });
      dispatch(
        dispatchPerformDisputeResolutionObj({
          ...requestCurrentDisData,
          state: { ...state, [name]: value, startingQtr: '', endingQtr: '' },
        })
      );
      let localErr = getErrorMsg || [];
      localErr = localErr?.filter(
        (item) => item.field !== 'endingQtr' && item.field !== 'startingQtr'
      );
      dispatch(dispatchErrorMsgDisputeRecap([...new Set(localErr)]));
    } else {
      setState({ ...state, [name]: value });
      dispatch(
        dispatchPerformDisputeResolutionObj({
          ...requestCurrentDisData,
          state: { ...state, [name]: value },
        })
      );
    }
  };

  // check validation for rebate program Dropdown
  const handleOnBlurEventOnFields = (value, name, type) => {
    dispatch(dispatchErrorMsgDisputeRecap([]));
    let localErr = getErrorMsg || [];
    if (name === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'notSelectedMFG'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'notSelectedMFG'
        );
      }
    }
    if (type === 'quarter') {
      if (name === 'startingQtr' && value?.trim()?.length === 0) {
        localErr.push({
          field: name,
          errorType: 'quarterRequired',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      } else if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) => item.field !== name && item.field !== 'notSelectedMFG'
          );
          if (name === 'startingQtr') {
            localErr = localErr?.filter(
              (item) =>
                item.field !== 'endingQtr' && item.field !== 'notSelectedMFG'
            );
            if (state?.endingQtr) {
              if (compareQtrs(value, state.endingQtr)) {
                localErr.push({
                  field: 'endingQtr',
                  errorType: 'invalidFormat',
                  message: constantMessageData.END_QTR_ERROR_UC,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'endingQtr' && item.field !== 'startingQtr'
                );
              }
              setState({
                ...state,
                startingQtr: autoFormateDate(value?.toUpperCase()),
              });
              dispatch(
                dispatchPerformDisputeResolutionObj({
                  ...requestCurrentDisData,
                  state: {
                    ...state,
                    startingQtr: autoFormateDate(value?.toUpperCase()),
                  },
                })
              );
            } else {
              setState({
                ...state,
                startingQtr: autoFormateDate(value?.toUpperCase()),
                endingQtr: autoFormateDate(value?.toUpperCase()),
              });
              dispatch(
                dispatchPerformDisputeResolutionObj({
                  ...requestCurrentDisData,
                  state: {
                    ...state,
                    startingQtr: autoFormateDate(value?.toUpperCase()),
                    endingQtr: autoFormateDate(value?.toUpperCase()),
                  },
                })
              );
            }
          }
          if (name === 'endingQtr' && value?.length > 0) {
            if (state?.startingQtr) {
              if (compareQtrs(state.startingQtr, value)) {
                localErr.push({
                  field: 'endingQtr',
                  errorType: 'invalidFormat',
                  message: constantMessageData.END_QTR_ERROR_UC,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'endingQtr' && item.field !== 'startingQtr'
                );
              }
            }

            setState({
              ...state,
              endingQtr: autoFormateDate(value?.toUpperCase()),
            });
            dispatch(
              dispatchPerformDisputeResolutionObj({
                ...requestCurrentDisData,
                state: {
                  ...state,
                  endingQtr: autoFormateDate(value?.toUpperCase()),
                },
              })
            );
          }
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== name && item.field !== 'notSelectedMFG'
          );
          localErr.push({
            field: name,
            errorType: 'invalidFormat',
            message: constantMessageData.VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== name && item.field !== 'notSelectedMFG'
        );
        if (value?.trim()?.length > 0) {
          localErr.push({
            field: name,
            errorType: 'invalidFormat',
            message: constantMessageData.VALIDATE_QUARTER_VALUE,
          });
        }
      }
    }
    dispatch(dispatchErrorMsgDisputeRecap([...new Set(localErr)]));
  };
  const rebateProgramName = rebateProgramList?.find(
    (item) => item.id === state?.rebateProgramCd
  );
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/disputeRecapitulation', true);
    } else {
      tabHighLigther('/disputeRecapitulation', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);
  const checkManufacturer = () => {
    setChecked(!checked);
  };

  // Grid functionality
  const onSelectionChanged = (e) => {
    dispatch(dispatchErrorMsgDisputeRecap([]));
    
    const api = e?.api || e;
    const rowIndex = e?.rowIndex ?? state.currentIndex;
    
    if (!api || typeof api.getSelectedRows !== 'function') {
      return;
    }
    
    const selectedRows = api.getSelectedRows() || [];
    dispatch(
      dispatchPerformDisputeResolutionObj({
        ...requestCurrentDisData,
        state: { ...state, currentIndex: rowIndex },
      })
    );
    
    const manufacturerListLength = Array.isArray(manufacturerList) ? manufacturerList.length : 0;
    
    if (
      selectedRows.length === manufacturerListLength ||
      selectedRows.length === 0
    ) {
      setMenuName(['All']);
    } else {
      const temp = [];
      const selectedMenuName = [];
      for (let i = 0; i < selectedRows.length; i += 1) {
        selectedMenuName.push(selectedRows[i]?.mfgName);
        temp.push({
          manufacturerID: selectedRows[i]?.mfgId,
          manufacturerName: selectedRows[i]?.mfgName,
        });
      }
      selectedMenuName.sort();
      setMenuName(selectedMenuName);
      setManufactureWithId(temp);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field !== 'notSelectedMFG');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgDisputeRecap(unique));
    }
  };

  const getSelectedRowData = (e) => {
    const selectedData = e.gridApi.getSelectedRows();
    return selectedData;
  };

  React.useEffect(() => {
    if (rebateProgramName)
      dispatch(
        getDramsInvStartQtr({
          rebateProgCode: rebateProgramName?.rebateProgramCd,
          allRpc: 0,
        })
      );
  }, [rebateProgramName]);
  React.useEffect(() => {
    setDramsData(getDRAMSListData?.dramsInvoiceStartQuarter);
  }, [getDRAMSListData]);
  // On search button functionality
  const displaySearch = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    let localErr = getErrorMsg || [];
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    if (
      !state?.startingQtr &&
      state?.qtrSelected === 'Selected Quarter Range'
    ) {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (!onDoubleClick && manufacturerWithId.length === 0) {
      localErr.push({
        field: 'notSelectedMFG',
        errorType: 'manufactureRequired',
        message: NOT_SELECTED_ROW,
      });
    }
    if (onDoubleClick && selectedRowOnDoubleClick.length === 0) {
      localErr.push({
        field: 'notSelectedMFG',
        errorType: 'manufactureRequired',
        message: NOT_SELECTED_ROW,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgDisputeRecap(unique));
    if (localErr.length === 0) {
      // current quarter
      const today = new Date();
      const quarter = Math.floor(today.getMonth() / 3) + 1;
      const year = today.getFullYear();
      const quarterString = quarter.toString();
      const yearString = year.toString();
      const formattedQuarter = quarterString.padStart(2);
      const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`;
      const rc = checked;
      const rClosed = rc === true ? 'R' : 'C';
      const drugSel =
        rc === true && state?.drugSelected === 'Current Disputes'
          ? rClosed
          : state?.drugSelected
            .replace('All Drugs', 'D')
            .replace('All Disputes', 'P')
            .replace('Current Disputes', 'C');

      const qtrSel = state?.qtrSelected
        .replace('All', 'A')
        .replace('DRAMS Invoice Start Quarter', 'S')
        .replace('Selected Quarter Range', 'R');
      const dateRange = {
        'DRAMS Invoice Start Quarter': {
          beginDate: dramsData,
          endDate: currentQuarterWithYear.trim(),
        },
        All: {
          beginDate: null,
          endDate: null,
        },
        'Selected Quarter Range': {
          beginDate: state?.startingQtr,
          endDate: state?.endingQtr
            ? state?.endingQtr
            : currentQuarterWithYear.trim(),
        },
      };
      dispatch(dispatchRecapGrid([]));
      setSearchClicked(true);
      dispatch(
        getDisplayRecapGrid({
          mfgId: onDoubleClick
            ? selectedRowOnDoubleClick[0]?.mfgId
            : manufacturerWithId[0]?.manufacturerID,
          rebateProgramCode: rebateProgramName?.rebateProgramCd,
          startQtr: dateRange[state?.qtrSelected]?.beginDate,
          endQtr: dateRange[state?.qtrSelected]?.endDate,
          asQtrOpt: qtrSel,
          asDrugSel: drugSel,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchDrugSelected(state?.drugSelected));
      dispatch(dispatchQuarterSelected(state?.qtrSelected));
      dispatch(dispatchRecentlyClosed(checked));
      dispatch(dispatchIncludeActivity(state?.checkBoxValue));
      dispatch(getManufactureName(menuName));
      dispatch(getManufactureID(manufacturerWithId));
      dispatch(
        dispatchDisplayObjRecap({
          rebateProgramName,
          checked,
          qtrSelected: state?.qtrSelected,
          checkBox: state?.checkBoxValue,
          allManufacturer: menuName,
          manufactureWithIds: manufacturerWithId,
          quarterFrom: state?.startingQtr,
          quarterTo: state?.endingQtr,
        })
      );
    }
  };
  React.useEffect(() => {
    if (dispute_codes && dispute_codes?.rebateRecapDisputeCodeVO?.length) {
      const ndcgrouping = Object.groupBy(
        dispute_codes.rebateRecapDisputeCodeVO,
        ({ ndc }) => ndc
      );
      if (getDisplayRecapGridList?.rebateRecapGridVO?.length) {
        let data = getDisplayRecapGridList?.rebateRecapGridVO?.map((obj) => {
          const matchedndc = ndcgrouping?.[obj?.ndc];
          if (matchedndc && matchedndc.length) {
            const qtrgrouping = Object.groupBy(
              matchedndc,
              ({ convertedQtr }) => convertedQtr
            );
            const matchedqtr = qtrgrouping?.[obj?.qtr];
            if (matchedqtr && matchedqtr.length) {
              let dispCd = matchedqtr.map((obj) => obj.disputeCode);
              dispCd = [...new Set(dispCd)];
              obj.dispCd = dispCd.join(',');
            }
          }
          return obj;
        });
        setProceed(true);
        dispatch(
          dispatchRecapGrid({
            ...getDisplayRecapGridList,
            rebateRecapGridVO: data,
          })
        );
        if (isSearchClicked) navigateToDetail();
      }
      dispatch(setLoading(false));
    } else if (
      isSearchClicked &&
      getDisplayRecapGridList?.rebateRecapGridVO?.length > 0
    ) {
      navigateToDetail();
      dispatch(setLoading(false));
    }
  }, [dispute_codes]);
  const [proceed, setProceed] = React.useState(false);
  const navigateToDetail = () => {
    setSearchClicked(false);
    setProceed(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayDisputeRecapitulation',
      value: 'Display Dispute Recapitulation',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props.history) {
      props.history.push({
        pathname: '/displayDisputeRecapitulation',
      });
      dispatch(clearReduxForFilterAndSort('/displayDisputeRecapitulation'));
    }
  };
  const cellClickedListener = (e) => {
    setManufactureWithId([e?.data]);
    displaySearch(null, true, [e?.data]);
  };

  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);
  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Dispute Recapitulation"
      />
      {/* <div id='errorScroll'> */}
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          ),
        ]}
      />
      {/* </div> */}

      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="radio-button-for-rcdd"
              id="radio-button-for-rcdd_id"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4 frr-two-col-radio ">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-0">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    name="rebateProgram"
                    id="rebate_program"
                    data-testid="rebate_program_disputeRecap"
                    label="Rebate Program"
                    fullWidth
                    select
                    required
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd'
                            ? 'mandate-fields'
                            : null
                        )
                        : null
                    }
                    onBlur={(e) =>
                      handleOnBlurEventOnFields(
                        e.target.value,
                        'rebateProgramCd'
                      )
                    }
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    value={
                      state && state.rebateProgramCd
                        ? state.rebateProgramCd
                        : '-1'
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-4" style={{ marginTop: '50px' }}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  name="includeActivityDetails"
                  checked={state?.checkBoxValue}
                  onChange={() =>
                    handleOnChangeEvent(!state?.checkBoxValue, 'checkBoxValue')
                  }
                />
              }
              label="Include Activity Details"
            />
          </div>
          <div className="row">
            <div
              className="col-6"
              style={{
                paddingTop: '20px',
                paddingLeft: '30px',
                // paddingRight: '230px',
              }}
            >
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Report Quarter Option <span className="mandatory"> *</span>{' '}
                </legend>
                <div className="form-wrapper p-0 ">
                  <div className="mui-custom-form  field-xl no-lbl">
                    <RadioGroup
                      row
                      name="QuarterRange"
                      value={state?.qtrSelected}
                      data-testid="qtrRange_disputeRecap"
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'qtrSelected');
                      }}
                    >
                      <FormControlLabel
                        value="All"
                        control={<Radio />}
                        label="All"
                        data-test="All"
                      />
                      <FormControlLabel
                        value="DRAMS Invoice Start Quarter"
                        control={<Radio />}
                        label="DRAMS Invoice Start Quarter"
                        data-test="DRAMS Invoice Start Quarter"
                      />

                      <FormControlLabel
                        value="Selected Quarter Range"
                        control={<Radio />}
                        label="Selected Quarter Range"
                        data-testid="selecterQtrRange_disputeRecap"
                      />
                    </RadioGroup>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <div className="heading">Begin</div>
                        <TextField
                          className="mandate-fields"
                          data-testid="check_From_Date"
                          id="startingQtr"
                          label="From"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ id: 'startingQtr', maxLength: 6 }}
                          fullWidth
                          placeholder=""
                          name="From"
                          value={state?.startingQtr}
                          onChange={(e) =>
                            handleOnChangeEvent(e.target.value, 'startingQtr')
                          }
                          disabled={
                            state?.qtrSelected !== 'Selected Quarter Range'
                          }
                          onBlur={(e) =>
                            handleOnBlurEventOnFields(
                              e.target.value,
                              'startingQtr',
                              'quarter'
                            )
                          }
                          helperText={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                l.field === 'startingQtr' ? l.message : null
                              )
                              : null
                          }
                          error={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                l.field === 'startingQtr' ? l.message : null
                              )
                              : null
                          }
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <div className="heading">End</div>
                        <TextField
                          className="mandate-fields "
                          data-testid="check_To_Date"
                          id="endingQtr"
                          label="End"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ id: 'endingQtr' }}
                          fullWidth
                          placeholder=""
                          name="to"
                          value={state?.endingQtr}
                          onChange={(e) => {
                            handleOnChangeEvent(e.target.value, 'endingQtr');
                          }}
                          disabled={
                            state?.qtrSelected !== 'Selected Quarter Range'
                          }
                          onBlur={(e) => {
                            handleOnBlurEventOnFields(
                              e.target.value,
                              'endingQtr',
                              'quarter'
                            );
                          }}
                          helperText={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                l.field === 'endingQtr' ? l.message : null
                              )
                              : null
                          }
                          error={
                            getErrorMsg?.length > 0
                              ? _.map(getErrorMsg, (l) =>
                                l.field === 'endingQtr' ? l.message : null
                              )
                              : null
                          }
                        />
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </fieldset>
            </div>
            <div
              className="col-6 "
              style={{
                paddingTop: '20px',
                // paddingLeft: '30px',
                paddingRight: '30px',
              }}
            >
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Drug Selection <span className="mandatory"> *</span>{' '}
                </legend>
                <div className="form-wrapper p-3 ">
                  <div className="mui-custom-form  field-xl no-lbl">
                    <RadioGroup
                      row
                      data-testid="dispRecap_drugSelection"
                      name="DrugSelection"
                      value={state?.drugSelected}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'drugSelected');
                      }}
                    >
                      <FormControlLabel
                        value="All Drugs"
                        control={<Radio />}
                        label="All Drugs"
                        data-test="All Drugs"
                      />
                      <FormControlLabel
                        value="All Disputes"
                        control={<Radio />}
                        label="All Disputes"
                        data-test="All Disputes"
                      />

                      <FormControlLabel
                        value="Current Disputes"
                        control={<Radio />}
                        label="Current Disputes"
                        data-test="Current Disputes"
                      />
                      <div
                        className="row custom-search-dates mt-3 "
                        style={{ paddingLeft: '15px' }}
                      >
                        <div className="col-12">
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                name="includeRecentlyClosed"
                                disabled={
                                  state?.drugSelected !== 'Current Disputes'
                                }
                                checked={checked}
                                onChange={checkManufacturer}
                              />
                            }
                            label="Include Recently Closed"
                          />
                        </div>
                      </div>
                    </RadioGroup>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-12 btn-wrapper mb-2"
            style={{ marginTop: '10px' }}
          >
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={displaySearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Search
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 ">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              getSelectedRowData={getSelectedRowData}
              gridCall={onGridReady}
             // gridDataRendered={onFirstDataRendered}
              ref={gridRef}
              data-testid="onEditingStopped"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              cellClickedListener={cellClickedListener}
              // selectRowIndex={selectRowIndexValue}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_350}
              columnDefs={AllManufacturer}
              rowData={manufacturerList}
              rowSelection="single"
              rowMultiSelectWithClick
              exportFile
              animateRows
              sideBar={false}
              fileName="Manufacturer Grid"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisputeRecapitulation;
